import React, { useRef, useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import Form from "react-bootstrap/Form";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { T } from "../components/helpful";
import { Tag } from "primereact/tag";
import { useSelector} from "react-redux";
import { daysOfWeek } from "./constant";
import { getWeddingDateStatus } from "../api/api";
import { numberToMonth } from "./utilities";
import {link} from "../config";

/**
 * Component that renders a calendar for a given month and year.
 * The calendar includes information about the status of each day.
 * 
 * @return {object[][]} A 2D array representing the calendar, where each inner array represents a week.
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com> 2024/05/12
 */
const WCalendar = () => {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  const { t } = useTranslation();
  const hotels = useSelector((state) => state.user.hotels);
  const userGroupID = useSelector((state) => state.user.userGroupID);
  const toast = useRef(null);
  const [hotel, setHotel] = useState(1);
  const [weddingDateStatus, setWeddingDateStatus] = useState([]);
  const [dateFrom, setDateFrom] = useState(firstDay);
  const [isAdmin, setIsAdmin] = useState(userGroupID === "1" || userGroupID === "26");
  const date = new Date(dateFrom);

  date.setMonth(date.getMonth() + 2);
  date.setDate(0); // return the last day of month
  
  const [dateTo, setDateTo] = useState(date);

  const status = [
    {
      id: 1,
      name: "Already Booked",
      code: "booked-status-1",
    },
    {
      id: 2,
      name: "Tentatively Booked",
      code: "booked-status-2",
    },
    {
      id: 3,
      name: "The Date Is Available",
      code: "booked-status-3",
    },
  ];

  useEffect(() => {
    
    getWeddingDate(dateFrom, dateTo, hotel);
  }, [dateFrom,dateTo,hotel]);

  useEffect(() => {
    const getDateIncremented = () => {
      const date = new Date(dateFrom);

      date.setMonth(date.getMonth() + 1);
      setDateTo(date);
    };
  
    getDateIncremented();
  }, [dateFrom]);

  const handleDateEnd = (date) => {
    setDateTo(date);
    date.setMonth(date.getMonth() - 1);
    setDateFrom(date);
  };
  const handleDateStart = (date) => {
    setDateFrom(date);
  };
  const handleFilter = (e) => {
    e.preventDefault();

    getWeddingDate(dateFrom, dateTo, hotel);
  };

  const getWeddingDate = async (dateFrom, dateTo, hotelID) => {
    /**
     * Retrieves the wedding date status for a given date range and hotel.
     *
     * @param {Date} dateFrom - The start date of the range.
     * @param {Date} dateTo - The end date of the range.
     * @param {number} hotelID - The ID of the hotel.
     * @return {any} The wedding date status.
     */
    let endDate = structuredClone(dateTo);
    endDate.setMonth(endDate.getMonth() + 1)
    endDate.setDate(0);
   
    const weddingDates = await getWeddingDateStatus(dateFrom, endDate, hotelID);
    
    
  
    setWeddingDateStatus(weddingDates);
  };

  const checkStatus = (currentDay, data, year, month) => {
    let temp = {};

    data.forEach((element) => {
      let day = parseInt(element.date.split("-")[2]);
      let calMonth = parseInt(element.date.split("-")[1]);
      let calYear = parseInt(element.date.split("-")[0]);

      if (day === currentDay && calMonth === month + 1 && calYear === year) {
        temp.id = element.id;
        temp.hotelID = element.hotelID;
        temp.wedTypeID = element.wedTypeID;
        temp.date = element.date;
        temp.status = element.status;
      }
    });
    
    return temp;
  };

  const createDays = (year, month, statusDay) => {
    /**
     * Generates a 2D array representing a calendar for a given month and year.
     * The calendar includes information about the status of each day.
     *
     * @param {number} year - The year for which to generate the calendar.
     * @param {number} month - The month for which to generate the calendar (0-based).
     * @param {object[]} statusDay - An array of objects containing information about the status of each day.
     * @return {object[][]} A 2D array representing the calendar, where each inner array represents a week.
     */

    const startDate = new Date(year, month, 0);
    const endDate = new Date(year, month + 1, 0);

    const daysInMonth = endDate.getDate();
    const startDayOfWeek = startDate.getDay(); // Sunday is 0, Monday is 1, etc.

    let currentDay = 1;
    let calendarDays = [];

    for (let i = 0; i < 6; i++) {
      let calendarRow = [];

      for (let j = 0; j < 7; j++) {
        if ((i === 0 && j < startDayOfWeek) || currentDay > daysInMonth) {
          calendarRow.push({
            td: "",
            id: 0,
            hotelID: 0,
            wedTypeID: 0,
            date: "",
            status: null,
          });
        } else {
          let resp = checkStatus(currentDay, statusDay, year, month);
          
          if (Object.keys(resp).length > 0) {
            calendarRow.push({
              td: currentDay,
              id: resp.id,
              hotelID: resp.hotelID,
              wedTypeID: resp.wedTypeID,
              date: resp.date,
              status: resp?.status === "" ? 3 : resp.status,
            });
          } else {
            let date = `${year}-${(month + 1)
              .toString()
              .padStart(2, "0")}-${currentDay.toString().padStart(2, "0")}`;
            calendarRow.push({
              td: currentDay,
              id: 0,
              hotelID: hotel,
              wedTypeID: 0,
              date: date,
              status: 3,
            });
          }
          currentDay++;
        }
      }
      calendarDays.push(calendarRow);
    }

    return calendarDays;
  };

  const AvailabilityForm = ({ item, callback ,initial,op}) => {
    const [selectedStatus, setSelectedStatus] = useState(null);
   
    const onStatusChange = async (e) => {
      item.status = e.value;
     
      callback(item);
      setSelectedStatus(e.value);
    };
    const saveWedStatus = (e) => {
   
      const formData = JSON.stringify({ formData: initial });

      fetch(link+"saveWeddingCalendar", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json, text/plain, */*",
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Save",
              detail: "Status saved successfully.",
              life: 3000,
            });
          } else {
            console.log("error");
          }
          op.current.toggle(e);
          getWeddingDate(dateFrom, dateTo, hotel);
          
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    const close = (e) => {
      op.current.toggle(e);
    };

    const selectedStatusTemplate = (option, props) => {
      if (option) {
        return (
          <div className="">
            <Tag value="" className={option.code + "  color-key "}></Tag>
            <span className="">{option.name} </span>
          </div>
        );
      }

      return <span>{props.placeholder}</span>;
    };
    const avaibilityOptionTemplate = (option) => {
      return (
        <div className="">
          <Tag value="" className={option.code + "  color-key "}></Tag>
          <span className="">{option.name} </span>
        </div>
      );
    };
    
  
    const [year, month, day] = item.date.split("-");
    let date = `${day}/${month}/${year}`;
    return (
      <Form className="">
        <div className="bold mb-2 text-end">{date}</div>
        <Dropdown
          value={selectedStatus}
          options={status}
          onChange={onStatusChange}
          optionLabel="name"
          optionValue="id"
          placeholder="Select avaibility"
          valueTemplate={selectedStatusTemplate}
          itemTemplate={avaibilityOptionTemplate}
        />
          <div className="mt-2 text-center">
            <hr />
            
            <button
              type="button"
              onClick={(e) => close(e)}
              className="btn bcb-btn bcb-btn-secondary  text-uppercase bcb-btn-small mx-3"
            >
              {t("cancel")}
            </button>
            <button
              type="button"
              onClick={(e) => saveWedStatus(e)}
              className="btn bcb-btn bcb-btn-primary text-uppercase bcb-btn-small  "
            >
              {t("save")}
            </button>
          </div>
      </Form>
    );
  };

  const GenerateCalendar = ({ date }) => {
    const [year, setYear] = useState(date.getFullYear());
    const [month, setMonth] = useState(date.getMonth());
    const [wedItem, setWedItem] = useState(null);
    const [wedForm, setWebForm] = useState(null);
    const op = useRef(null);

    const row = createDays(year, month, weddingDateStatus);
   

    useEffect(()=>{

    },[wedForm])
    const handleWeddingStatus = useCallback(
       (item) => {
       
        setWebForm({
          id: item.id,
          date: item.date,
          hotelID: item.hotelID,
          status: item.status,
          wedTypeID: item.wedTypeID,
        });
      },
      []
    );

    const showTemplate = (e, item) => {
      e.preventDefault();
     
      setWedItem(item);
      op.current.toggle(e);
    };

    


    return (
      <div className="calendar-container">
        <Toast ref={toast} />
        
        <OverlayPanel ref={op} >
          <AvailabilityForm item={wedItem} callback={handleWeddingStatus} initial={wedForm} op={op}/>
        </OverlayPanel>
        <table className="calendar-table">
          <caption>
            {" "}
            <h3 className="py-2 text-center">
              {numberToMonth(month)} {year}
            </h3>{" "}
          </caption>
          <thead>
            <tr>
              {daysOfWeek.map((day, index) => (
                <th key={index}>{t(day)}</th>
              ))}
            </tr>
          </thead>
          <tbody id="calendar-body">
            {row.map((tr, index) => (
              <tr key={index}>
                {tr.map((item, i) => (
                  <td key={i} className="">
                    <span
                      className={
                        "" +
                        (item.status
                          ? "booking-day booked-status-" + item.status
                          : "")
                      }
                      onClick={(e) =>
                        isAdmin ? showTemplate(e, item) : null
                      }
                    >
                      {item.td}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  const Disclaimer = () => {
    const [isclose, setIsclose] = useState(false);
    return (
      <div className={isclose ? "h" : " disclaimer "}>
        <button
          className="close-btn"
          aria-label="Close"
          onClick={(e) => {
            setIsclose(true);
          }}
        >
          &times;
        </button>
        <h6>Note: Update on Calendar Status Information</h6>
        <p>
        Kindly note that the wedding calendar is being updated and shall be available in the coming days.
        </p>
      </div>
    );
  };

  return (
    <> 
    {weddingDateStatus?.length>0 ? null: 
    <div className="px-4">
 <Disclaimer />
    </div>
   }

      <div className="main-content">
        <Form className="">
          <Row className="filter g-2 ">
           
                <div className="col-12  col-sm-1 col-lg-1 mx-2 filter-icon-block">
                  <h6>
                    <T value={"Filters"} /> :
                  </h6>
                  <i className="bi bi-sliders filter-icon"></i>
                </div>
                <div className="col-12 col-sm-4 col-md-4 col-xl-4">
                  <Form.Group>
                    <Form.Label className="">
                      <T value={"Hotels"} /> :
                    </Form.Label>
                    <Form.Select
                      aria-label=""
                      name="hotel"
                      id="hotel"
                      value={hotel}
                      placeholder={<T value={"Select Hotel"} />}
                      className=""
                      onChange={(e) => setHotel(e.target.value)}
                    >
                      {hotels.map((hotel, index) => {
                        return (
                          <option value={hotel.hotel_id} key={index}>
                            {hotel.hotel_name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-12 col-sm-3 col-md-3 col-xl-3">
                  <Form.Group>
                    <Form.Label className="d-block">
                      <T value={"From"} /> :
                    </Form.Label>
                    <Calendar
                      maxDate={dateTo}
                      className="col-12"
                      value={dateFrom}
                      view="month"
                      dateFormat="mm/yy"
                      onChange={(e) => handleDateStart(e.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-sm-3 col-md-3 col-xl-3">
                  <Form.Group>
                    <Form.Label className="d-block">
                      <T value={"To"} /> :
                    </Form.Label>
                    <Calendar
                      minDate={dateFrom}
                      value={dateTo}
                      view="month"
                      dateFormat="mm/yy"
                      className="col-12"
                      onChange={(e) => handleDateEnd(e.value)}
                    />
                  </Form.Group>
                </div>

                <div className="col col-auto ">
                  <Button
                    variant="dark"
                    className="col-12"
                    onClick={handleFilter}
                    id="btn-filter"
                  >
                    <i className="bi bi-caret-right-fill"></i>
                  </Button>
                </div>
              
          </Row>
        </Form>
        
      </div>

      <div className="row g-2 px-3  mt-5">
        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
          <GenerateCalendar date={dateFrom} />
        </div>
        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
          <GenerateCalendar date={dateTo} />
        </div>
      </div>
    </>
  );
};

export default WCalendar;
